import React from 'react';

const MarkdownSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-gray-100 dark:bg-gray-800 p-4">
      <div className="w-full max-w-3xl space-y-4">
        <div className="animate-fadePulse">
          <div className="h-8 bg-gray-300 dark:bg-gray-600 rounded w-1/3" /> 
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-full" />
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-5/6" />
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-4/5" />
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-3/4" />
        </div>
      </div>
    </div>
  );
};

export default MarkdownSkeleton;